document.addEventListener('DOMContentLoaded', () => {
    const collectionTabItems = document.querySelectorAll('.collection-tab-item');
    const collectionGridItems = document.querySelectorAll('.collection-product-grid-item');

    if (collectionTabItems.length === 0) {
        return;
    }

    const scrollableContainer = document.querySelector('.collection-tab-wrapper');

    function updateActiveTab(activeTab) {
        collectionTabItems.forEach(tab => {
            tab.classList.remove('is-active');
            const imageContainer = tab.querySelector('.collection-tab-image-container');
            if (imageContainer) {
                imageContainer.classList.remove('border-[0.5px]', 'border-black');
            }
        });
        if (!activeTab) {
            return;
        }
        activeTab.classList.add('is-active');
        const imageContainer = activeTab.querySelector('.collection-tab-image-container');
        if (imageContainer) {
            imageContainer.classList.add('border-[0.5px]', 'border-black');
        }
    }

    function toggleGridItems(collectionHandle) {
        const currentCollectionGridItems = document.querySelectorAll('.collection-product-grid-item');

        if (collectionHandle === 'all') {
            currentCollectionGridItems.forEach(gridItem => {
                gridItem.classList.remove('hidden');
            });
            return;
        }
        currentCollectionGridItems.forEach(gridItem => {
            gridItem.classList.add('hidden');
        });

        const targetGrid = document.querySelector(
            `.collection-product-grid[data-collection-handle="${collectionHandle}"]`
        );
        if (targetGrid) {
            const gridItem = targetGrid.closest('.collection-product-grid-item');
            if (gridItem) {
                gridItem.classList.remove('hidden');
            }
        }
    }

    function getActiveTabFromURL() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('tab') || 'all';
    }

    function setActiveTabFromURL() {
        const activeCollectionHandle = getActiveTabFromURL();
        const activeTab = document.querySelector(`.collection-tab-item[data-collection-handle="${activeCollectionHandle}"]`);
        if (activeTab) {
            updateActiveTab(activeTab);
            toggleGridItems(activeCollectionHandle);
        } else {
            const allTab = document.querySelector('.collection-tab-item[data-collection-handle="all"]');
            if (allTab) {
                updateActiveTab(allTab);
                toggleGridItems('all');
            }
        }
    }

    window.setActiveTabFromURL = setActiveTabFromURL;
    setActiveTabFromURL();

    // Handle browser back/forward navigation
    window.addEventListener('popstate', () => {
        setActiveTabFromURL();
    });

    collectionTabItems.forEach(tabItem => {
        tabItem.addEventListener('click', (e) => {
            e.preventDefault();

            const collectionHandle = tabItem.getAttribute('data-collection-handle');

            if (!collectionHandle) {
                return;
            }

            const currentUrl = new URL(window.location.href);
            if (collectionHandle === 'all') {
                currentUrl.searchParams.delete('tab');
            } else {
                currentUrl.searchParams.set('tab', collectionHandle);
            }
            window.history.pushState({}, '', currentUrl.toString());

            updateActiveTab(tabItem);

            toggleGridItems(collectionHandle);

            if (scrollableContainer) {
                const containerRect = scrollableContainer.getBoundingClientRect();
                const tabRect = tabItem.getBoundingClientRect();

                const isFullyVisible =
                    tabRect.left >= containerRect.left &&
                    tabRect.right <= containerRect.right;

                if (!isFullyVisible) {
                    const tabLeft = tabRect.left - containerRect.left + scrollableContainer.scrollLeft;
                    const tabWidth = tabRect.width;
                    const containerWidth = containerRect.width;
                    const scrollPosition = tabLeft - (containerWidth / 2) + (tabWidth / 2);

                    scrollableContainer.scrollTo({
                        left: scrollPosition,
                        behavior: 'smooth'
                    });
                }
            }

            if (collectionHandle === 'all') {
                if (collectionGridItems.length > 0) {
                    const firstGridItem = collectionGridItems[0];
                    const headerOffset = 100;
                    const elementPosition = firstGridItem.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            } else {
                const targetGrid = document.querySelector(
                    `.collection-product-grid[data-collection-handle="${collectionHandle}"]`
                );

                if (targetGrid) {
                    const headerOffset = 100;
                    const elementPosition = targetGrid.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }
        });
    });
});

